export function useStringParams (string, params) {
  let result = string;
  if (result && params) {
    Object.keys(params).forEach((param) => {
      result = result.replace(`{{${param}}}`, params[param])
    });
  };
  return result;
}